import { combineReducers } from 'redux'
import alert from './components/Alert/Alert.state'
import confirm from './components/Confirm/Confirm.state'
import panel from './components/Panel/Panel.state'
import progressBar from './components/ProgressBar/ProgressBar.state'
import adminPanel from './components/admin/Panel/Panel.state'
import labelBuilder from './views/LabelBuilder/LabelBuilder.slice'
import workOrderCalendar from './views/WorkOrderCalendar/WorkOrderCalendar.slice'
import items from './views/Items/Items.slice'
import workOrders from './views/WorkOrders/WorkOrders.slice'
import receivings from './views/Receivings/Receivings.slice'
import inventories from './views/Inventories/Inventories.slice'
import barePallets from './views/BarePallets/BarePallets.slice'
import shipOrders from './views/ShipOrders/ShipOrders.slice'
import purchaseOrders from './views/PurchaseOrders/PurchaseOrders.slice'
import billsOfLading from './views/BillsOfLading/BillsOfLading.slice'
import standaloneCases from './views/StandaloneCases/StandaloneCases/StandaloneCases.slice'
import consumedCases from './views/StandaloneCases/ConsumedCases/ConsumedCases.slice'
import packTraces from './views/PackTraces/PackTraces.slice'
import collapsibleMenu from './components/CollapsibleMenu/CollapsibleMenu.slice'
import customLabels from './views/CustomLabels/CustomLabels.slice'
import systemLabels from './views/SystemLabels/SystemLabels.slice'
import customLabelPrintsPaginate from './views/CustomLabelPrintsPaginate/CustomLabelPrintsPaginate.slice'

const reducers = combineReducers({
  alert,
  confirm,
  panel,
  progressBar,
  adminPanel,
  labelBuilder,
  workOrderCalendar,
  items,
  workOrders,
  receivings,
  inventories,
  barePallets,
  purchaseOrders,
  billsOfLading,
  shipOrders,
  standaloneCases,
  consumedCases,
  packTraces,
  collapsibleMenu,
  customLabels,
  systemLabels,
  customLabelPrintsPaginate,
})

export default reducers
